import { render, staticRenderFns } from "./Stockist.vue?vue&type=template&id=51aeb587&"
import script from "./Stockist.vue?vue&type=script&lang=js&"
export * from "./Stockist.vue?vue&type=script&lang=js&"
import style0 from "./Stockist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports